import CityServicePage from "@/pages/city-service/CityServicePage";
import { mississaugaHeatingCooling } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={mississaugaHeatingCooling} />; }
